<h2 mat-dialog-title>Historie</h2>

<mat-dialog-content>
    @if (!data.items?.length) {
        <p class="mat-text-disabled">Er is nog geen historie voor deze planning.</p>
    } @else {
        <div class="history-table-wrapper">
            <table class="table table-striped table-hover history-table">
                <colgroup>
                    <col class="col-date" />
                    <col class="col-user" />
                    <col class="col-source" />
                    <col class="col-field" />
                    <col class="w-50" />
                    <col class="w-50" />
                </colgroup>
                <thead>
                    <tr>
                        <th class="col-date">Datum</th>
                        <th class="col-user">Gebruiker</th>
                        <th class="col-source">Bron</th>
                        <th class="col-field">Veld</th>
                        <th class="col-old">Oud</th>
                        <th class="col-new">Nieuw</th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of data.items; track $index) {
                        @let source = item | sourceLabel: entities : users : getDriverIdAsOf(item);
                        @let hasSource = item.source === 'user_planning' || source.kind !== null;

                        <tr>
                            <td class="fw-bold col-date text-end">
                                <div class="text-truncate">
                                    <span class="capitalized-date">{{ item.created_at | date: dateFormat }}</span>
                                </div>
                            </td>
                            <td class="col-user">
                                <div class="text-truncate">
                                    {{ (users | byId: item.changed_by_id)?.name ?? 'Onbekend' }}
                                </div>
                            </td>
                            @if (hasSource) {
                                <td class="col-source">
                                    <div class="text-truncate">
                                        @if (item.source === 'user_planning') {
                                            <i class="fa-regular fa-user"></i>
                                            {{ (users | byId: item.user_id)?.name ?? 'Onbekend' }}
                                        } @else if (source.kind === 'personnel') {
                                            <i class="fa-regular fa-user"></i>
                                            {{ source.name }}
                                        } @else if (source.kind === 'materiel') {
                                            <i class="fa-regular fa {{ source.icon }}"></i>
                                            {{ source.name }}
                                            @if (source.driverName) {
                                                (<i class="fa-regular fa-user"></i> {{ source.driverName }})
                                            }
                                        }
                                    </div>
                                </td>
                            }
                            <td class="col-field" [attr.colspan]="hasSource ? null : 2">
                                <div class="text-truncate">{{ getLabel(item.field) }}</div>
                            </td>
                            <td
                                class="col-old text-decoration-line-through"
                                [class.history-textarea]="isTextareaField(item.field)"
                                [class.text-end]="isDateField(item)">
                                @if (isDateField(item)) {
                                    <span class="capitalized-date">
                                        {{ item.date_old_value ? (item.date_old_value | date: dateFormat) : '-' }}
                                    </span>
                                } @else if (isCheckboxField(item.field)) {
                                    {{ item.old_value === '1' || item.old_value === 'true' ? 'Ja' : 'Nee' }}
                                } @else if (isUserIdField(item.field)) {
                                    {{
                                        item.old_value ? ((users | byId: +item.old_value)?.name ?? item.old_value) : '-'
                                    }}
                                } @else if (isEntityIdField(item.field)) {
                                    {{
                                        item.old_value
                                            ? ((entities | byId: +item.old_value)?.name ?? item.old_value)
                                            : '-'
                                    }}
                                } @else {
                                    {{ item.old_value || '-' }}
                                }
                            </td>
                            <td
                                class="col-new"
                                [class.history-textarea]="isTextareaField(item.field)"
                                [class.text-end]="isDateField(item)">
                                @if (isDateField(item)) {
                                    <span class="capitalized-date">
                                        {{ item.date_new_value ? (item.date_new_value | date: dateFormat) : '-' }}
                                    </span>
                                } @else if (isCheckboxField(item.field)) {
                                    {{ item.new_value === '1' || item.new_value === 'true' ? 'Ja' : 'Nee' }}
                                } @else if (isUserIdField(item.field)) {
                                    {{
                                        item.new_value ? ((users | byId: +item.new_value)?.name ?? item.new_value) : '-'
                                    }}
                                } @else if (isEntityIdField(item.field)) {
                                    {{
                                        item.new_value
                                            ? ((entities | byId: +item.new_value)?.name ?? item.new_value)
                                            : '-'
                                    }}
                                } @else {
                                    {{ item.new_value || '-' }}
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button mat-button mat-dialog-close>Sluiten</button>
</mat-dialog-actions>
